import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import uuid from 'uuid/v4';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { ACTIONS } from './states';
export var reducer = function reducer(pluginState, action) {
  switch (action.type) {
    case ACTIONS.CLEAR_INLINE_SUGGESTION:
      return _objectSpread(_objectSpread({}, pluginState), {}, {
        inlineSuggestion: null,
        decorationSet: DecorationSet.empty,
        inlineSuggestionSessionId: null
      });
    case ACTIONS.UPDATE_INLINE_SUGGESTION:
      {
        var sessionID = null;
        if (action.payload.inlineSuggestion) {
          sessionID = pluginState.inlineSuggestion ? pluginState.inlineSuggestionSessionId : uuid();
        }
        return _objectSpread(_objectSpread({}, pluginState), {}, {
          inlineSuggestion: action.payload.inlineSuggestion,
          decorationSet: action.payload.decorationSet,
          inlineSuggestionSessionId: sessionID
        });
      }
    case ACTIONS.UPDATE_LOCALE:
      {
        return _objectSpread(_objectSpread({}, pluginState), {}, {
          locale: action.payload.locale
        });
      }
    default:
      return pluginState;
  }
};